import React, { useState, useEffect } from "react";

const FindingOffersLoading = ({ setCurrentStep, formData }) => {
  const [progress, setProgress] = useState(0);
  const [activeCheckIndex, setActiveCheckIndex] = useState(0);

  const loadingSteps = [
    "Mobile Verified",
    "Income Profile Matched",
    "Checking Credit Profile",
    "Comparing 100+ Lender Options",
    "Finding Best Offers",
  ];

  useEffect(() => {
    const progressInterval = setInterval(() => {
      setProgress((prev) => (prev >= 100 ? 100 : prev + 1));
    }, 30); 

    const checkInterval = setInterval(() => {
      setActiveCheckIndex((prev) => (prev >= loadingSteps.length ? prev : prev + 1));
    }, 600);

    return () => {
      clearInterval(progressInterval);
      clearInterval(checkInterval);
    };
  }, []);

  useEffect(() => {
    if (progress === 100 && activeCheckIndex >= loadingSteps.length) {
      const timeout = setTimeout(() => {
        setCurrentStep(6);
      }, 400);
      return () => clearTimeout(timeout);
    }
  }, [progress, activeCheckIndex, setCurrentStep]);

  return (
    <div 
      className="flex flex-col min-h-[100dvh] max-w-[400px] w-full mx-auto bg-white antialiased text-[#111827] pt-16 px-6"
      style={{ fontFamily: '"SF Pro", "SF Pro Display", -apple-system, sans-serif' }}
    >
      
      <div className="mb-10 mt-4">
        <h1 className="text-[24px] font-bold tracking-tight mb-2 leading-tight">
          Finding your loan offers...
        </h1>
        <p className="text-gray-400 text-[14px]">
          Checking lenders that may suit your profile.
        </p>
      </div>

      <div className="flex-1">
        <div className="flex flex-col">
          {loadingSteps.map((step, index) => {
            const isChecked = index < activeCheckIndex;
            return (
              <div 
                key={index} 
                className={`flex items-center gap-4 py-4 border-b border-gray-100 transition-opacity duration-500 ${
                  index <= activeCheckIndex ? "opacity-100" : "opacity-30"
                }`}
              >
                <div 
                  className={`w-6 h-6 flex-none rounded-full flex items-center justify-center transition-colors duration-300 ${
                    isChecked ? "bg-[#12F280]" : "bg-gray-200"
                  }`}
                >
                  {isChecked && (
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                  )}
                </div>
                <span className="text-[14px] font-semibold text-gray-800">
                  {step}
                </span>
              </div>
            );
          })}
        </div>
      </div>

      <div className="pb-12 pt-6">
        <div className="h-1.5 w-full bg-[#c9f7e0] rounded-full overflow-hidden">
          <div 
            className="h-full bg-[#12F280] transition-all duration-75 ease-linear"
            style={{ width: `${progress}%` }}
          ></div>
        </div>
        <p className="text-[11px] text-gray-400 mt-2 font-medium">
          {progress}% Complete
        </p>
      </div>
    </div>
  );
};

export default FindingOffersLoading;